import { useTranslation } from 'react-i18next';
import { useSelector } from 'app/lib/hooks';
import { selectSetEnvironmentError } from 'app/store/jobs';
import { Button, ButtonSize } from 'app/components/core/Button';
import { Submit } from 'app/components/core/Form';
import { ErrorBanner } from 'app/components/composite/ErrorBanner';
import { CreateEnvironmentForm } from 'app/components/features/CreateEnvironmentDialog';
import { DialogPanel, DialogActions } from 'app/components/features/DialogWithChapters';

export function ConfigureEnvironmentPanel({ id, open, environment, onCancel }) {
    const { t } = useTranslation();
    const error = useSelector(selectSetEnvironmentError);
    const label = t('jobs:dialogs.environment.title', {
        context: environment ? 'edit' : 'create'
    });

    return (
        <DialogPanel id={id} label={label} open={open}>
            {error && <ErrorBanner error={error} />}
            <CreateEnvironmentForm environment={environment}>
                <DialogActions>
                    <Button onClick={onCancel} size={ButtonSize.MEDIUM}>
                        {t('common:cancel')}
                    </Button>
                    <Submit size={ButtonSize.MEDIUM}>
                        {environment ? t('common:update') : t('common:create')}
                    </Submit>
                </DialogActions>
            </CreateEnvironmentForm>
        </DialogPanel>
    );
}
